export default __webpack_public_path__ + "static/media/benefit_icon_request.719cd708.svg";